import { firebaseApp } from "./firebase";
import "firebase/storage";

export const firestorageBank = firebaseApp.storage("gs://bank-batchs");
export const standardBucket = firebaseApp.storage("gs://enercred.appspot.com");
